import React from 'react';
import changeProviderProvider from 'mn-utils/changeProviderProvider';
import handleProviderProvider from 'mn-utils/changeProviderProviderSimple';
import delay from 'mn-utils/delay';
import noop from 'mn-utils/noop';
import map from 'mn-utils/map';

import {
  COINS,
} from '../../../../../constants';

import {
  LINK_WITHDRAWAL_ACCOUNTS,
} from '../../../../../constants/links';
import {
  pushLocation,
} from '../../../../../router';
import withState from '../../../../../utils/withState';
import {
  openPopupInfo,
} from '../../../../../emitters/popup';
import ButtonBack from '../../../../dumb/Button/BackB';
import Button from '../../../../dumb/Button/Accept';
import Caption from '../../../../dumb/Caption/C';
import Field from '../../../../dumb/Field/E';
import Select from '../../../../dumb/Select/H';
import TextField from '../../../../dumb/TextField/A';
import WrapperWithLoading from '../../../../dumb/WrapperWithLoading/B';
import openPopupDeleteBankAccount from './components/openPopupDeleteCryptoAccount';
import {
  apiV2CryptoAccountCreate,
  apiV2CryptoAccountsGet,
  apiV2CryptoAccountsList, apiV2CryptoAccountUpdate,
} from '../../../../../api/merchant/cryptoAccounts';

const {
  cryptoAccountId$,
} = require('./state');

function handleBack() {
  pushLocation({
    path: LINK_WITHDRAWAL_ACCOUNTS,
  });
}

module.exports = withState((setState, self, onMount) => {
  self.state = {
    clicked: false,
    network: '',
    address: '',
    coin: '',
    cryptoCoins: map(COINS, (el) => ({...el, disabled: false})),
    networks: map(['Bitcoin', 'Etherium', 'Bitcom cash'], (id) => ({id, disabled: false})),
  };

  onMount(() => {
    apiV2CryptoAccountsList({
      limit: 1000,
      offset: 0,
    }).then((response) => {
      setState({
        banksLoading: false,
        banks: response.list || [],
      });
    });
  });

  let _id;
  let _cancel = noop;

  function update() {
    _cancel();
    _cancel = delay(() => {
      setState({
        loading: true,
      });

      _cancel = apiV2CryptoAccountsGet({
        id: _id,
      }).finally((error, response) => {
        response = response || {};
        setState({
          loading: false,
          ...response,
        });
      }).cancel;
    });
  }

  const changeProvider = changeProviderProvider(setState);
  const handleProvider = handleProviderProvider(setState);

  const handleChangeCurrency = handleProvider('coin');
  const handleChangeAddress = changeProvider('address');
  const handleChangeNetwork = handleProvider('network');

  return (state, props) => {
    const id = state.id;
    const edit = !!id && id !== 'create';

    edit && _id !== id && update(_id = id);

    const {clicked} = state;

    function handleSave() {
      if (disabled) {
        setState({
          clicked: true,
        });
        return;
      }

      setState({
        loading: true,
      });

      const params = {
        network: state.network,
        address: state.address,
        coin: state.coin,
      };
      (
        edit
          ? (
            params.id = id,
            apiV2CryptoAccountUpdate(params)
          )
          : apiV2CryptoAccountCreate(params)
      ).finally((error) => {
        setState({
          loading: false,
        });
        if (error) {
          return;
        }
        handleBack();
        openPopupInfo([
          edit
            ? 'Bank account has been changed'
            : 'Bank account has been created',
        ]);
      });
    }

    return (
      <WrapperWithLoading
        className={props.className || ''}
        loading={state.loading}
      >
        <div className="layoutRow fhaB fvaC">
          <ButtonBack
            className="m-10 mr10"
            onClick={handleBack}
          />
          <Caption>
            {edit ? 'Edit Account' : 'Add your new you deposit crypto Account'}
          </Caption>
          {edit && (
            <a
              className="f12 fw4 cE70F0F"
              onClick={() => {
                const data = {
                  id,
                  name: state.name,
                  iban: state.iban,
                  fiat_code: state.currency,
                  swift_code: state.swiftCode,
                };
                openPopupDeleteBankAccount(data, () => {
                  handleBack();
                });
              }}
            >Delete account</a>
          )}
        </div>

        <div className="cfx mh-28 (w1/2|ph28|w@m|lt)>1">
          <div className="mt26">
            <Field
              label="Cryptocurrency *"
            >
              <Select
                className="f12 lh17 fw7"
                propName="id"
                propValue="id"
                value={state.coin}
                items={state.cryptoCoins}
                onChange={handleChangeCurrency}
                error={clicked}
                helperText="Obligatory field"
              />
            </Field>
          </div>
          <TextField
            className="mt26"
            label="Crypto Address*"
            value={state.address}
            onChange={handleChangeAddress}
            error={clicked}
          />
          <div className="mt26">
            <Field
              label="Network *"
            >
              <Select
                className="f12 lh17 fw7"
                propName="id"
                propValue="id"
                value={state.network}
                items={state.networks}
                onChange={handleChangeNetwork}
                error={clicked}
                helperText="Obligatory field"
              />
            </Field>
          </div>
        </div>
        <div className="mt30 layoutRow fhaS fvaC">
          <Button
            disabled={clicked && disabled}
            onClick={handleSave}
          >Save Account</Button>
        </div>
      </WrapperWithLoading>
    );
  };
}, {
  id: cryptoAccountId$,
});
